// src/assets/components/ThemeToggle.jsx
import React, { useEffect, useState, useCallback } from "react";
import { Sun, Moon } from "lucide-react";

const STORAGE_KEY = "theme";

function applyTheme(theme) {
  const root = document.documentElement;
  const body = document.body;
  root.setAttribute("data-theme", theme);
  body.classList.toggle("dark-mode", theme === "dark");
}

function getInitialTheme() {
  try {
    const saved = localStorage.getItem(STORAGE_KEY);
    if (saved === "dark" || saved === "light") return saved;
  } catch { }
  // fallback: preferência do sistema
  const prefersDark = window.matchMedia && window.matchMedia("(prefers-color-scheme: dark)").matches;
  return prefersDark ? "dark" : "light";
}

export default function ThemeToggle() {
  // ⬇️ já inicia com o valor correto
  const [theme, setTheme] = useState(() => getInitialTheme());

  // aplica e persiste sempre que mudar
  useEffect(() => {
    applyTheme(theme);
    try { localStorage.setItem(STORAGE_KEY, theme); } catch { }
  }, [theme]);

  // sincroniza entre abas
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === STORAGE_KEY && (e.newValue === "dark" || e.newValue === "light")) {
        setTheme(e.newValue);
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const toggle = useCallback(() => {
    setTheme((t) => (t === "dark" ? "light" : "dark"));
  }, []);

  const isDark = theme === "dark";

  return (
    <button
      type="button"
      className="btn theme-toggle-btn"
      onClick={toggle}
      role="switch"
      aria-checked={isDark}
      aria-label={isDark ? "Alternar para modo claro" : "Alternar para modo escuro"}
      title={isDark ? "Alternar para modo claro" : "Alternar para modo escuro"}
    >
      {isDark ? <Sun size={18} aria-hidden="true" /> : <Moon size={18} aria-hidden="true" />}
      <span className="theme-toggle-text">{isDark ? "Claro" : "Escuro"}</span>
    </button>
  );
}
